import { ContactDetail } from 'store/slices/customerSlice';
import { store } from 'store/store';

const testMock = async (onSubmit) => {
	const cpr = '0101651111';

	await onSubmit({
		...prepareSubmit('CUSTOMER_CPR', cpr),
		...prepareSubmit('CUSTOMER_AGE', getAgeFromCpr(cpr)),
		...prepareSubmit('PT_PT_PTO_COVER_RANGE', '02'),
		...prepareSubmit('PT_PT_PTO_NUMBER_ADULTS', '3'),
		...prepareSubmit('PT_PT_PTO_TRAVEL_DAYS', '60'),
		...prepareSubmit('CUSTOMER_FULL_ADDRESS', 'Bournonvillesvej 1a, 3480 Fredensborg'),
	});
};

export const mapCustomerData = async (onSubmit): Promise<void> => {
	const customerId = store.getState().customer?.customer_id;
	if (!customerId) {
		return;
	}

	const toSubmit: { [key: string]: any } = {
		...prepareSubmit('CUSTOMER_ID', customerId),
		...getEmail(),
		...getPhone(),
		...getName(),
		...getAddress(),
		...getCprAndAge(),
	};

	// await testMock(onSubmit);

	await onSubmit(toSubmit);
};

const getEmail = () => {
	const contactDetail = findContactDetail('Email__c');
	return prepareSubmit('CUSTOMER_EMAIL', contactDetail?.detail);
};

const getPhone = () => {
	let contactDetail = findContactDetail('Mobile__c');

	if (contactDetail?.detail) {
		return prepareSubmit('CUSTOMER_PHONE', contactDetail?.detail);
	}

	// look for landline phone
	contactDetail = findContactDetail('Phone');
	return prepareSubmit('CUSTOMER_PHONE', contactDetail?.detail);
};

const getName = () => {
	const person = store.getState().customer?.person;
	const firstName = person?.firstname ?? '';
	const lastName = person?.lastname ?? '';

	const fullName = `${firstName} ${lastName}`.trim();
	if (fullName !== '') {
		return prepareSubmit('CUSTOMER_FULL_NAME', fullName);
	}
};

const getCprAndAge = () => {
	const person = store.getState().customer?.person;
	if (!person?.cpr_nr) {
		return;
	}
	return {
		...prepareSubmit('CUSTOMER_CPR', person.cpr_nr),
		...prepareSubmit('CUSTOMER_AGE', getAgeFromCpr(person.cpr_nr)),
	};
};

const getAddress = () => {
	// SalesForce doesn't send correct address - missing floor and side, also kvhx is not present
	const address = store.getState().customer?.contact?.address;
	if (!address) {
		return;
	}
	const floorNr = findContactDetail('Floor__c')?.detail;
	const floorSide = findContactDetail('Floor_Side_Code__c')?.detail;
	const floorDoor = findContactDetail('Floor_Door__c')?.detail;

	let addr = address?.street_name + ' ' + address?.building_no_and_letter + ', ';
	if (floorNr) {
		addr += floorNr + '. ';
	}
	if (floorSide) {
		addr += floorSide + '. ';
	}
	if (floorDoor) {
		addr += floorDoor + '. ';
	}
	addr += address?.postal_code + ' ' + address?.city_name;

	return {
		...prepareSubmit('CUSTOMER_FULL_ADDRESS', addr),
		...prepareSubmit('PT_PT_PTO_POST_AREA', address?.postal_code?.toString()), // TODO FIX zipcode problem for other products
	};
};

const findContactDetail = (id: string): ContactDetail => {
	return store.getState().customer?.contact?.contact_details?.find((detail) => detail.type === id);
};

const prepareSubmit = (id: string, value: string) => {
	return value
		? {
				[id]: {
					id,
					value,
				},
			}
		: undefined;
};

const getAgeFromCpr = (cpr: string): string => {
	const value = cpr.trim().replace(/\D/g, '');
	const dateNow = new Date();
	const thisYear = dateNow.getFullYear() - 2000;
	let year = parseInt(value.slice(4, 6));
	if (year > thisYear) {
		year = 1900 + year;
	} else {
		year = 2000 + year;
	}

	const dateThen = new Date(year, parseInt(value.slice(2, 4)) - 1, parseInt(value.slice(0, 2)));

	let diffYears = dateNow.getFullYear() - dateThen.getFullYear();
	const diffMonths = dateNow.getMonth() - dateThen.getMonth();
	const diffDays = dateNow.getDate() - dateThen.getDate();

	if (diffMonths < 0) {
		diffYears--;
	}
	if (diffMonths === 0 && diffDays < 0) {
		diffYears--;
	}
	if (diffYears < 0 || diffYears > 100) {
		return undefined;
	}
	return diffYears + '';
};
